/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Target_Folder_ButtonInputs */



/**
* | output |
* | --- |
* | "Target Folder" |
*
* @param {Drastic_Tech_Target_Folder_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_target_folder_button = /** @type {((inputs?: Drastic_Tech_Target_Folder_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Target_Folder_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dossier cible")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zielordner")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cartella di destinazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Целевая папка")
	if (locale === "es") return /** @type {LocalizedString} */ ("Carpeta de destino")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("目标文件夹")
	if (locale === "ja") return /** @type {LocalizedString} */ ("対象フォルダ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लक्ष्य फ़ोल्डर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pasta de destino")
	return /** @type {LocalizedString} */ ("Target Folder")
});